<style scoped>
.dialog-card {
  background: white 0% 0% no-repeat padding-box;
}

.dialog-card--large {
  box-shadow: 8px 8px 23px #b9b9b9, -8px -8px 23px #ffffff !important;
}

.dialog-btn {
  background: white 0% 0% no-repeat padding-box;
}

.dialog-btn--large {
  box-shadow: 4px 4px 10px #838383, -4px -4px 10px #ffffff !important;
}

.dialog-header {
  background-color: #1b2643;
  border-radius: 3px;
  height: 60px;
  color: white;
  font-size: 14px;
}
</style>

<template>
  <v-dialog v-model="dialogVisible" width="400px" persistent>
    <v-card class="mx-auto dialog-card dialog-card--large">
      <v-card-title class="justify-center dialog-header">
        {{ $t('viewCouponLists.resetPasswordConfirmationDialog.title') }}
      </v-card-title>
      <v-card-text class="text-center pt-8 pb-4">
        <p class="text-body-1">
          {{
            $t('viewCouponLists.resetPasswordConfirmationDialog.message', {
              username,
            })
          }}
        </p>
      </v-card-text>
      <v-card-actions class="justify-center pb-6">
        <v-btn
          color="#1b2643"
          class="dialog-btn dialog-btn--large px-7"
          dark
          @click="handleOk"
        >
          {{ $t('viewCouponLists.resetPasswordConfirmationDialog.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "ResetPasswordConfirmationDialog",

  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    username: {
      type: String,
      required: true,
    },
  },

  computed: {
    dialogVisible: {
      get(): boolean {
        return this.isVisible;
      },
      set(value: boolean) {
        this.$emit("update:isVisible", value);
      },
    },
  },

  methods: {
    handleOk() {
      this.dialogVisible = false;
    },
  },
});
</script>
